'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FeaturesListConst = undefined;

var _values = require('babel-runtime/core-js/object/values');

var _values2 = _interopRequireDefault(_values);

exports.getFeaturesForServer = getFeaturesForServer;

var _Guid = require('./Guid');

var _Guid2 = _interopRequireDefault(_Guid);

var _Error = require('./Error');

var _Cookie = require('../server/Cookie');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FeaturesListConst = exports.FeaturesListConst = {
  AnonymousLogin: 'ANONYMOUS_LOGIN',
  FreeModeAvailable: 'FREE_MODE_AVAILABLE',
  LinkIdentityToAccount: 'LINK_IDENTITY_TO_ACCOUNT',
  MusicAuthorization: 'MUSIC_AUTHORIZATION',
  SongSkip: 'SONG_SKIP'
};

function getFeaturesForServer(req, res, lang, sessionId, productRealm, operatorId, version, errorRedirect, loginClient, callback) {
  var correlationId = (0, _Guid2.default)();
  var promise = loginClient.appFeatures.features({
    supportedFeatures: (0, _values2.default)(FeaturesListConst),
    sessionId: sessionId,
    operatorId: operatorId,
    languageTag: lang,
    clientId: req.query.client_id,
    feVersion: version
  }, { responseContentType: 'application/json', 'correlation-id': correlationId });

  promise.then(function (result) {
    callback(loginClient, result.obj.features);
  });
  promise.catch(function (error) {
    if (error.obj && error.obj.code === _Error.ErrorConst.InvalidValue && error.obj.field === _Error.ErrorFieldConst.SessionId) {
      _Cookie.Cookie.clearSessionId(req, res, productRealm);
      sessionId = '';
    }
    errorRedirect(req, res, error, correlationId, sessionId);
  });
}


//////////////////
// WEBPACK FOOTER
// ./src/helpers/Features.js
// module id = 814
// module chunks = 0